import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";

function Google_play_left(props) {
  const vht = useSelector((state) => state.qwickSilver);
  let last_coupon_order_at = vht?.data?.response?.last_coupon_order_at;

  return (
    <Stack spacing={2}>
      <Stack spacing={1} direction="row" flexWrap="wrap" gap={4}>
        <Stack spacing={1} direction="row">
          <Typography>Amount</Typography>
          <Typography color="primary">{props.price || "--"}</Typography>
        </Stack>
        <Stack spacing={1} direction="row">
          <Typography>Coupon left</Typography>
          <Typography color="primary">
            {(vht?.data?.response?.left_coupons || vht?.data?.response?.left_coupons == 0)
              ? vht?.data?.response?.left_coupons
              : "--"}
          </Typography>
        </Stack>
      </Stack>
      <Stack spacing={1} direction="row" flexWrap="wrap" gap={4}>
        <Stack spacing={1} direction="row">
          <Typography>Last Coupon Order</Typography>
          <Typography color="primary">{last_coupon_order_at || "--"}</Typography>
        </Stack>
        <Stack spacing={1} direction="row">
          <Typography>Last Coupon Order Price</Typography>
          <Typography color="primary">{vht?.data?.response?.last_coupon_order_price || "--"}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default Google_play_left;
